import { z } from "zod";

const serviceAccountBaseFields = {
  name: z.string().min(1, "Le nom est requis"),
  email: z.email("Adresse e-mail invalide"),
  cities: z.array(z.string()).min(1, "Sélectionnez au moins une ville"),
};

export const createServiceAccountSchema = z.object(serviceAccountBaseFields);

export const updateServiceAccountSchema = z.object(serviceAccountBaseFields);

export type CreateServiceAccountFormValues = z.infer<typeof createServiceAccountSchema>;
export type UpdateServiceAccountFormValues = z.infer<typeof updateServiceAccountSchema>;

export const defaultServiceAccount = {
  name: "",
  email: "",
  cities: [] as string[],
};

export const SERVICE_ACCOUNTS_TAB = "Service Accounts" as const;
